import { styled } from '@acko-tech/building-blocks.ui.common';
import { Input } from '@acko-tech/building-blocks.ui.input';

export const CustomInput = styled(Input)`
    > div {
        > input {
            padding: 20px 10px;
            font-size: 16px;
            line-height: 20px;
        }

        &:focus-within > label {
            transform: translateY(-38px);
        }

        > div {
            right: 15px;
        }
    }
`;

export const Forward = styled.div`
    height: 12px;
    width: 12px;
    border: 3px solid transparent;
    border-left: 3px solid white;
    border-bottom: 3px solid white;
    transform: rotate(225deg);
    border-radius: 2px;
    cursor: pointer;
`;

type ButtonContainerProps = {
    disabled: boolean;
};

export const ButtonContainer = styled.div`
    padding: 10px 15px 10px 5px;
    background-color: ${(props: ButtonContainerProps) =>
        props.disabled ? '#E0E0E8' : '#0fa457'};
    pointer-events: ${(props: ButtonContainerProps) =>
        props.disabled && 'none'};
    border-radius: 8px;
`;

export const Container = styled.div`
    min-height: 100px;
    > h6 {
        margin: 20px 0;
    }
`;

export const LoaderContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

export const LoaderText = styled.div`
    font-weight: 600;
    padding-left: 8px;
    margin: 18px 0;
`;

export const InfoContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

export const InfoText = styled.div`
    margin: 30px 0;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
`;

export const CTAContainer = styled.div`
    margin: 30px 0 8px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
`;

export const Link = styled.span`
    font-weight: 500;
    font-size: 14px;
    color: #1b73e8;
`;
